module.exports = __webpack_public_path__ + "static/img/DSC_2672.f016e71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2672.jpg
// module id = 271
// module chunks = 0